var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form-controll', {
    attrs: {
      "field": _vm.field
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(api) {
        return [_c('autosuggest', {
          attrs: {
            "items": _vm.items,
            "select": _vm.select,
            "readonly": _vm.readonly,
            "value": api.getValue(),
            "name": _vm.field,
            "caption": _vm.caption,
            "label": _vm.label,
            "error": api.getTouched() ? api.getError() : undefined,
            "placeholder": _vm.placeholder
          },
          on: {
            "input": api.setValue,
            "blur": api.setTouched
          }
        })]
      }
    }])
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60dfa968","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/sign/baseComponents/Form/FormSelect.vue
// module id = 823
// module chunks = 0